(() => {
  if (customElements.get('europelab-reviews')) return;
  customElements.define('europelab-reviews', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.er__reviews');
      this.controls = this.querySelector('.er__controls');
      this.prev = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      if (!this.track || !this.controls) return;
      this.abort?.abort();
      this.stopAuto();
      this.hovered = false;
      this.focused = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.prev.addEventListener('click', () => { this.move(-1); this.restartAuto(); }, options);
      this.next.addEventListener('click', () => { this.move(1); this.restartAuto(); }, options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.syncAuto(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.syncAuto(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.syncAuto(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.syncAuto(); }, options);
      this.track.addEventListener('pointerdown', () => { this.dragging = true; this.stopAuto(); }, options);
      document.addEventListener('pointerup', () => { this.dragging = false; this.restartAuto(); }, options);
      document.addEventListener('pointercancel', () => { this.dragging = false; this.restartAuto(); }, options);
      document.addEventListener('visibilitychange', () => this.syncAuto(), options);
      this.motion.addEventListener('change', () => this.syncAuto(), options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    move(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.controls.hidden = max < 3;
      this.prev.disabled = this.track.scrollLeft < 3;
      this.next.disabled = this.track.scrollLeft >= max - 3;
      this.syncAuto();
    }
    syncAuto() {
      const canRun = !this.hovered && !this.focused && !this.dragging && !document.hidden && !this.motion.matches && this.track.scrollWidth - this.track.clientWidth > 3;
      if (!canRun) { this.stopAuto(); return; }
      if (this.timer) return;
      this.timer = setInterval(() => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (this.track.scrollLeft >= max - 3) this.track.scrollTo({ left: 0, behavior: 'smooth' });
        else this.move(1);
      }, 2000);
    }
    stopAuto() { if (this.timer) clearInterval(this.timer); this.timer = null; }
    restartAuto() { this.stopAuto(); this.syncAuto(); }
    disconnectedCallback() { this.stopAuto(); this.abort?.abort(); this.resize?.disconnect(); }

  });
})();
